export default __webpack_public_path__ + "img/cloudy-rain.8d122f6.svg";